<div class="tooltip-arrow" data-popper-arrow></div>
<div class="tooltip-inner">
  <ng-container #tooltipTemplate></ng-container>
</div>
